import React from 'react';
import { ResponsiveContainer, BarChart, Bar, YAxis, XAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

import './style.scss';


class NPBarChart extends React.Component {
  formatNumber(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  render() {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let graphData = this.props.graphData;
    var s = "";
    let fmt=this.formatNumber;
    if(this.props.logisticsData) {
      if (Array.isArray(graphData) && graphData.length) {
        graphData = graphData.map(x => {
          return {
            sortBy: s.concat(x.Year, x.Month),
            "Month": x.Year + '/' + months[x.Month - 1],
            "Planned weight": x.Planned_Weight,
            "Shipped weight": x.Shipped_Weight,
            year: x.Year
          };
        });
      }
    } else {
      if (Array.isArray(graphData) && graphData.length) {
        graphData = graphData.map(x => {
          return {
            sortBy: s.concat(x.Year, x.Month),
            "Month": x.Year + '/' + months[x.Month - 1],
            "Ordered weight": x.Ordered_Weight,
            "Stock weight": x.Stock_Weight,
            "Shipped weight": x.Shipped_Weight,
            year: x.Year            
          };
        });
      }
    }

    let node = (<div></div>)
    
    if(graphData) {
      node = (
        <ResponsiveContainer minHeight={500} >
          <BarChart data={graphData} stackOffset="wiggle">
            <XAxis dataKey="Month" xAxisId={0} />
            <XAxis dataKey="Month" xAxisId={1} hide />
            <XAxis dataKey="Month" xAxisId={2} hide />
            <YAxis
              tickFormatter={(tick) => fmt(tick) }
            />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            {this.props.logisticsData && <Bar dataKey="Planned weight" xAxisId={0} fill="#F39C12" />} 
            {!this.props.logisticsData && <Bar dataKey="Ordered weight" xAxisId={0} fill="#F39C12" />}
            {!this.props.logisticsData && <Bar dataKey="Stock weight" xAxisId={1} fill="#00529c" />}
            {!this.props.logisticsData && <Bar dataKey="Shipped weight" xAxisId={2} fill="#3498DB" />}
            {this.props.logisticsData && <Bar dataKey="Shipped weight" xAxisId={1} fill="#3498DB" />}
          </BarChart>
        </ResponsiveContainer>
      );
    }

    return (node)
  }
}

export default NPBarChart;